import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './WorkpapersView.sass'
import WorkpapersMenu from './WorkpapersMenu'
import WorkpapersHeader from './WorkpapersHeader'
import WorkpapersFooter from './WorkpapersFooter'
import WorkpapersForm from './WorkpapersForm'
import WorkpapersPreviewer from './WorkpapersPreviewer'
import WorkpapersRootViewModel from './WorkpapersRootViewModel'

interface Props {
  vm: WorkpapersRootViewModel
}

export default observer(function WorkpapersView({ vm }: Props) {
  if (!vm.workpaper) {
    return <EmptyState />
  }

  return (
    <div className={cx(styles.container, vm.isMenuOpen && styles.split)}>
      <div className={cx(styles.root)}>
        <WorkpapersMenu
          workpapers={vm.workpapers}
          selectedWorkpaper={vm.workpaper}
          onItemClick={vm.edit}
        />

        <div className={cx(styles.main)}>
          <WorkpapersHeader
            completedCount={vm.validatedWorkpapersCount}
            totalCount={vm.workpapersCount}
            onMenuClick={vm.toggleMenu}
            onDownloadClick={() => vm.downloadCsv()}
            onDrakeDownloadClick={() => vm.drakeDownload()}
          />

          <div className={cx(styles.content)}>
            <WorkpapersPreviewer vm={vm.workpaper.previewerVM} />

            <WorkpapersForm vm={vm.workpaper.formVM} />
          </div>

          <WorkpapersFooter
            onButtonClick={vm.cycleWorkpaper}
            selectedWorkpaper={vm.workpaper}
          />
        </div>
      </div>
    </div>
  )
})

const EmptyState = function () {
  return (
    <div className={styles.container}>
      <div className={styles.root}>
        <div className={styles.main}>
          <WorkpapersHeader completedCount={0} totalCount={0} />

          <div className={cx(styles.content, styles.empty)}>
            No Documents have been uploaded
          </div>
        </div>
      </div>
    </div>
  )
}
